import { type ExtraValues, type PlatformEvent } from '../types';

export const playClickEvent = (extra?: ExtraValues): PlatformEvent => {
  return {
    type: 'click',
    created: Date.now(),
    user_properties: {
      ...(extra && { ...extra.user_properties }),
    },
    event_properties: {
      name: 'play_click',
      event_source: 'front',
      ...(extra && { ...extra.event_properties }),
    },
  };
};
